// extracted by mini-css-extract-plugin
export var grid = "_o-0";
export var span1 = "_o-2";
export var span10 = "_o-b";
export var span10L = "_o-z";
export var span10M = "_o-n";
export var span10Xl = "_o-1b";
export var span11 = "_o-c";
export var span11L = "_o-10";
export var span11M = "_o-o";
export var span11Xl = "_o-1c";
export var span12 = "_o-d";
export var span12L = "_o-11";
export var span12M = "_o-p";
export var span12Xl = "_o-1d";
export var span1L = "_o-q";
export var span1M = "_o-e";
export var span1Xl = "_o-12";
export var span2 = "_o-3";
export var span2L = "_o-r";
export var span2M = "_o-f";
export var span2Xl = "_o-13";
export var span3 = "_o-4";
export var span3L = "_o-s";
export var span3M = "_o-g";
export var span3Xl = "_o-14";
export var span4 = "_o-5";
export var span4L = "_o-t";
export var span4M = "_o-h";
export var span4Xl = "_o-15";
export var span5 = "_o-6";
export var span5L = "_o-u";
export var span5M = "_o-i";
export var span5Xl = "_o-16";
export var span6 = "_o-7";
export var span6L = "_o-v";
export var span6M = "_o-j";
export var span6Xl = "_o-17";
export var span7 = "_o-8";
export var span7L = "_o-w";
export var span7M = "_o-k";
export var span7Xl = "_o-18";
export var span8 = "_o-9";
export var span8L = "_o-x";
export var span8M = "_o-l";
export var span8Xl = "_o-19";
export var span9 = "_o-a";
export var span9L = "_o-y";
export var span9M = "_o-m";
export var span9Xl = "_o-1a";
export var stretch = "_o-1";